import React from 'react';
import { useCombat } from './combat.jsx';

// Slim banner atop every room — the current monster at its live HP + run tally.
const CombatHud = () => {
  const { monsterData, hp, maxHp, hpPct, kills } = useCombat();

  return (
    <div className="combatHudBar">
      <span className="chbLabel">{monsterData.name}</span>
      <span className="chbBar">
        <span className="chbFill" style={{ width: `${hpPct}%` }} />
        <span className="chbText">
          {hp} / {maxHp}
        </span>
      </span>
      <span className="chbKills">⚔ {kills} felled</span>
    </div>
  );
};

export default CombatHud;
